<script setup lang="ts">
import { computed } from 'vue';
import {
    quizPerformanceToGradeString,
    type QuizPerformance,
    type PersonalInformationRow,
    QuizStatus,
} from '@/types/Performance';

const props = defineProps<{
    testName?: string;
    testRow: PersonalInformationRow;
}>();

const score = computed(() => quizPerformanceToGradeString(props.testRow.finalQuizScore));
const test = computed(() => (
    typeof props.testRow.finalQuizScore !== 'string' ? props.testRow.finalQuizScore : null
));
const quizNotStarted = computed(() => (test.value as QuizPerformance).status === QuizStatus.notStarted);
const completedDate = computed(() => props.testRow.dateCompleted ?? '--');
const testTime = computed(() => props.testRow.totalTime ?? '--');
</script>

<template>
    <tr class="bottom-row">
        <td
            colspan="3"
            class="text-bold text-left"
        >
            {{ testName }} Test
        </td>
        <td
            colspan="2"
            class="text-bold text-left"
        >
            Score: {{ score }}
            <span
                v-if="test && !quizNotStarted"
                class="review-button q-pl-md"
            >
                <router-link
                    v-slot="{ href }"
                    class="text-fsum-blue"
                    :to="{
                        name: 'testReview',
                        params: {
                            schoolSlug: $route.params.schoolSlug,
                            courseSlug: $route.params.courseSlug,
                            cusId: $route.params.cusId,
                            testId: test.testSessionId,
                            testType: test.type,
                        }
                    }"
                    custom
                >
                    <q-btn
                        label="Review"
                        :ripple="false"
                        class="anchor-button text-body2"
                        color="fsum-blue"
                        icon-right="sym_o_arrow_forward_ios"
                        no-caps
                        dense
                        flat
                        :to="href"
                    />
                </router-link>
            </span>
        </td>
        <td
            colspan="2"
            class="text-bold text-right"
        >
            Completion Date: {{ completedDate }}
        </td>
        <td
            colspan="3"
            class="text-bold text-right"
        >
            Test Time: {{ testTime }}
        </td>
    </tr>
</template>
